import ad from './lib/ad';
import gdprNotice from './modules/gdprNotice';
import searchForm from './modules/searchForm';

export default function() {
    $(function() {
        if ($('lottie-player').length) {
            import('@lottiefiles/lottie-player');
        }

        if ($('select').length) {
            import('../vendor/jquery-select')
                .then(() => {
                    $('select').selectOverlap();
                    $('.search-type.static, .search-type.interactive').toggleClass('hide');
                    $('.search-type.interactive')
                        .parent('.select-holder')
                        .css('display', 'inline-block');
                });
        }

        gdprNotice.addGDPR();

        searchForm.init($('#newsearch'));

        ad.adResize($('.ad-950'), 950);
        ad.adResize($('.ad-725'), 725);
        ad.adResize($('.ad-728'), 728);
        ad.adResize($('.ad-300'), 300);
        
        $(window).on('resize', function() {
            ad.adResize($('.ad-950'), 950);
            ad.adResize($('.ad-725'), 725);
            ad.adResize($('.ad-728'), 728);
            ad.adResize($('.ad-300'), 300);
        });

        const $cookieBanner = $('#cookierBanner');
        $cookieBanner.attr('src', $cookieBanner.attr('data-src'));
    });
}

function ckEventUrl(ckEventReq) {
    let ck23f3543Timer = null;
    try {
        let ckImg = $(document.createElement('img'));
        ckImg.attr('src', ckEventReq);
        ckImg.appendTo('body');
        ckImg.addClass('hide');

        ckImg.onload = ckImg.onerror = function () {
            window.clearTimeout(ck23f3543Timer);
        };
    } catch (err) {
        window.clearTimeout(ck23f3543Timer);
    }
}
